export default __webpack_public_path__ + "static/media/power-meter.28cfc215.svg";